import { getBlockConfigs } from './block.utils.js';
import { compileProps } from './props-compiler.utils.js';
export const compileBlock = (options) => {
    var _a, _b;
    const { context, registeredBlock, block, parentsMapping, restrictions } = options;
    const { nonEditableBlocks = [], lockedChildrenBlocks = [], nonRemovableBlocks = [], } = restrictions || {};
    const defaultProps = (_a = registeredBlock.config) === null || _a === void 0 ? void 0 : _a.defaultProps;
    const props = Object.assign(Object.assign({}, defaultProps), block.props);
    const compiledProps = compileProps(props, context);
    const config = getBlockConfigs({
        block,
        registeredBlock,
        props,
        compiledProps,
        context,
    });
    const compiledBlock = {
        id: block.id,
        parentId: parentsMapping[block.id],
        name: block.name,
        props,
        extraProps: block.extraProps || {},
        compiledProps,
        children: block.children || [],
        config: Object.assign(Object.assign({}, config), { editable: config.editable !== false &&
                ((_b = registeredBlock.config) === null || _b === void 0 ? void 0 : _b.Settings) &&
                !nonEditableBlocks.includes(block.id), lockedChildren: config.lockedChildren || lockedChildrenBlocks.includes(block.id), removable: config.removable !== false && !nonRemovableBlocks.includes(block.id) }),
        Component: registeredBlock.Component,
        output: block.output || {},
    };
    return compiledBlock;
};
export const compileSlate = (kit, rawSlate, context) => {
    const parentsMapping = {};
    rawSlate.blocks.forEach(block => {
        var _a;
        (_a = block.children) === null || _a === void 0 ? void 0 : _a.forEach(child => {
            parentsMapping[child] = block.id;
        });
    });
    const compiledSlate = Object.assign(Object.assign({}, rawSlate), { blocks: rawSlate.blocks.reduce((pre, block) => {
            const registeredBlock = kit.getRegisteredBlock(block.name);
            if (!registeredBlock)
                return pre;
            return Object.assign(Object.assign({}, pre), { [block.id]: compileBlock({
                    context,
                    registeredBlock,
                    block,
                    parentsMapping,
                    restrictions: rawSlate.restrictions,
                }) });
        }, {}) });
    compiledSlate.blocks[compiledSlate.rootBlock].config.removable = false;
    return compiledSlate;
};
//# sourceMappingURL=slate-compiler.utils.js.map